export const locale = {
    id: 'uk-UA'
}
